import { useEffect, useState } from 'react'
import { ChevronRight, ExpandMore } from '@mui/icons-material'
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view'
import { useFetchContext } from '../../hook/UseFetchContext'
import { SET_NOEUD_OUVERT, SET_NOEUD_SELECTED } from '../../lib/typeKey'
import { useNavigate } from 'react-router'
import { getLanguePourLesUnitesPasEnFrancais } from './langUnite'

const styles = {
  '.MuiTreeItem-content[data-selected]': {
    backgroundColor: 'selected.cadre',
    color: 'selected.texte',
    fontWeight: 'bold'
  },
  '.MuiTreeItem-content[data-selected]:hover, .MuiTreeItem-content[data-selected][data-focused]': {
    backgroundColor: 'selected.cadre'
  },
  '.MuiTreeItem-content:hover, .MuiTreeItem-content[data-focused]': {
    backgroundColor: 'hover.cadre'
  },
  '.MuiTreeItem-content:hover': {
    userSelect: 'text'
  }
}

const ArbreUnite = () => {
  const { state, dispatch } = useFetchContext()
  const noeuds = state.dimensionState.noeuds
  const noeudOuvert = state.noeudOuvertState.noeudOuvert
  const noeudSelected = state.noeudSelectedState.noeudSelected
  const [noeudsSommet, setNoeudsSommet] = useState<INoeudDimension[]>([])
  const [noeudsAvecEnfants, setNoeudsAvecEnfants] = useState<{ [key: string]: INoeudDimension[] }>({})
  const navigate = useNavigate()

  useEffect(() => {
    // création d'une liste de tous les noeuds avec pour chacun ses enfants
    let newList = {}
    noeuds.forEach(
      (noeud: INoeudDimension) =>
        (newList = {
          ...newList,
          [noeud.identifiantNoeudDimension]: noeuds.filter(
            (n2: INoeudDimension) => n2.identifiantNoeudParent === noeud.identifiantNoeudDimension
          )
        })
    )
    setNoeudsAvecEnfants(newList)
    // récupération dans les données des noeuds sommets, c-a-d ceux pour qui identifiantNoeudParent = null
    setNoeudsSommet(noeuds.filter((noeud: INoeudDimension) => noeud.identifiantNoeudParent === null))
  }, [noeuds])

  // lors d'un click sur un noeud, permet de déplier/replier ce noeud
  const selectionNoeud = (idNoeud: any) => {
    dispatch({ type: SET_NOEUD_SELECTED, payload: idNoeud })

    if (noeudOuvert.includes(idNoeud)) {
      const nouveauxNoeuds = noeudOuvert.filter((noeud: string) => noeud !== idNoeud)
      dispatch({ type: SET_NOEUD_OUVERT, payload: nouveauxNoeuds })
    } else {
      const nouveauxNoeuds = [...noeudOuvert]
      nouveauxNoeuds.push(idNoeud)
      dispatch({ type: SET_NOEUD_OUVERT, payload: nouveauxNoeuds })
    }
  }

  // ajoute à l'arborescence une modalité et toute sa descendance
  const affichageDescendants = (noeud: INoeudDimension) => {
    const listeFils = noeudsAvecEnfants[noeud.identifiantNoeudDimension] // récupération des noeuds enfants du noeud en paramètre
    return (
      // création d'un TreeItem pour le noeud et de manière récursive pour ses enfants
      <TreeItem
        sx={styles}
        contextMenu="true"
        key={noeud.identifiantNoeudDimension}
        itemId={noeud.identifiantNoeudDimension}
        label={noeud.libelle.split('~')[0]}
        slotProps={{
          label: {
            style: { fontWeight: 'inherit' }
          }
        }}
        title={noeud.libelle}
        data-cy={`noeud-unite-${noeud.identifiantNoeudDimension}`}
        {...getLanguePourLesUnitesPasEnFrancais(noeud)}
      >
        {listeFils.map((fils: any) => affichageDescendants(fils))}
      </TreeItem>
    )
  }

  const onNodeSelect = (_event: any, id: any) => {
    selectionNoeud(id)
    navigate('/')
  }

  return (
    <SimpleTreeView
      sx={{ userSelect: 'none' }}
      aria-label="Navigation dans l'arbre des unités"
      slots={{ collapseIcon: ExpandMore, expandIcon: ChevronRight }}
      expandedItems={noeudOuvert}
      onSelectedItemsChange={onNodeSelect}
      selectedItems={noeudSelected}
    >
      {noeudsSommet.map((n) => affichageDescendants(n))}
    </SimpleTreeView>
  )
}

export default ArbreUnite
